import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./components/page-essentials/Footer";
import Nav from "./components/page-essentials/Nav";
import About from "./components/pages/About";
import Blogs from "./components/pages/Blogs";
import Contact from "./components/pages/Contact";
import GlobalPackages from "./components/pages/GlobalPackages";
import Home from "./components/pages/Home";
import LocalPackages from "./components/pages/LocalPackages";
import PackageDetails from "./components/pages/PackageDetails";
import Reviews from "./components/pages/Reviews";
import TravelGuide from "./components/pages/TravelGuide";
import Booking from "./components/pages/Booking";
function App() {
  return (
    <div>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/trek-au-nepal" element={<GlobalPackages />} />
        <Route path="/local-packages" element={<LocalPackages />} />
        <Route path="/review" element={<Reviews />} />
        <Route path="/travel-guide" element={<TravelGuide />} />
        <Route path="/package-details" element={<PackageDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/booking" element={<Booking />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
